module.exports = __webpack_public_path__ + "img/20180815_151629_182.648c494c.jpg";